import apiClient from '../../../shared/api/apiClient';

/**
 * Metadata-only wire contract for the super-admin PCF run history.
 * Customer model/config/output data, display identities, raw errors, and
 * artifact identifiers are never part of these responses.
 */
export interface AdminPcfRunListItem {
  id: string;
  company_id: string;
  user_id: string;
  trace_id: string | null;
  status: string;
  error_stage: string | null;
  started_at_utc: string | null;
  finished_at_utc: string | null;
  duration_ms: number;
  grouping: number;
  element_count: number;
  files_produced: number;
  plugin_version: string | null;
  pipeline_version: string;
  git_sha: string | null;
  local_cache_hit: boolean;
}

export interface AdminPcfRunListResponse {
  items: AdminPcfRunListItem[];
  total: number;
}

export interface AdminPcfRunDetail extends AdminPcfRunListItem {
  created_at_utc: string;
  retention_clear_at: string | null;
}

export interface ListRunsQuery {
  status?: string;
  from?: string;
  to?: string;
  skip?: number;
  limit?: number;
}

function cleanParams(q: ListRunsQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (q.status) {
    out.status = q.status;
  }
  if (q.from) {
    out.from = q.from;
  }
  if (q.to) {
    out.to = q.to;
  }
  if (typeof q.skip === 'number') {
    out.skip = q.skip;
  }
  if (typeof q.limit === 'number') {
    out.limit = q.limit;
  }
  return out;
}

export const userErrorsApi = {
  listRuns: async (query: ListRunsQuery): Promise<AdminPcfRunListResponse> => {
    const response = await apiClient.get<AdminPcfRunListResponse>('/admin/pcf-runs', {
      params: cleanParams(query),
    });
    return response.data;
  },

  getRunDetail: async (traceId: string): Promise<AdminPcfRunDetail> => {
    const response = await apiClient.get<AdminPcfRunDetail>(
      `/admin/pcf-runs/${encodeURIComponent(traceId)}`
    );
    return response.data;
  },
};
